import { GlobalAdapterUtil } from "../../../../api/GlobalAdapter";
import { StoryNodeDisplayType } from "../../../../storyV2/domain/StoryNodeDisplayType";
export class CustomApiTransformUtil {
    static isUploadFileType(displayType) {
        return this.uploadFileTypes.includes(displayType);
    }
    static getDisplayTypeByHeaders(headers) {
        const nodeDisplayType = this.getNodeDisplayTypeByHeaders(headers);
        if (nodeDisplayType) {
            return nodeDisplayType;
        }
        const contentType = headers?.get("Content-Type");
        if (contentType) {
            for (const [key, _displayType] of this.mimeTypesMap) {
                const regex = new RegExp(`^${key}`);
                if (regex.test(contentType)) {
                    const _displayType = this.mimeTypesMap.get(key);
                    if (!_displayType) {
                        continue;
                    }
                    return _displayType;
                }
            }
        }
        return StoryNodeDisplayType.TEXT;
    }
    static getNodeDisplayTypeByHeaders(headers) {
        const nodeType = headers?.get(GlobalAdapterUtil.customApiNodeTypeHeaderName);
        if (nodeType) {
            const _nodeDisplayType = this.nodeTypesMap.get(nodeType);
            if (_nodeDisplayType) {
                return _nodeDisplayType;
            }
        }
        return undefined;
    }
}
CustomApiTransformUtil.uploadFileTypes = [
    StoryNodeDisplayType.UPLOADIMAGE,
    StoryNodeDisplayType.BASEVIDEO,
    StoryNodeDisplayType.AUDIO,
    StoryNodeDisplayType.PDFFILE,
    StoryNodeDisplayType.TABLE,
    StoryNodeDisplayType.HTML,
    StoryNodeDisplayType.UPLOADFILE,
];
CustomApiTransformUtil.nodeTypesMap = new Map([
    ["uploadImage", StoryNodeDisplayType.UPLOADIMAGE],
    ["baseVideo", StoryNodeDisplayType.BASEVIDEO],
    ["audio", StoryNodeDisplayType.AUDIO],
    ["pdfFile", StoryNodeDisplayType.PDFFILE],
    ["table", StoryNodeDisplayType.TABLE],
    ["html", StoryNodeDisplayType.HTML],
    ["askBrain", StoryNodeDisplayType.ASKBRAIN],
]);
CustomApiTransformUtil.mimeTypesMap = new Map([
    ["image/", StoryNodeDisplayType.UPLOADIMAGE],
    ["video/", StoryNodeDisplayType.BASEVIDEO],
    ["audio/", StoryNodeDisplayType.AUDIO],
    ["application/pdf", StoryNodeDisplayType.PDFFILE],
    ["text/csv", StoryNodeDisplayType.TABLE],
    ["application/vnd.ms-excel", StoryNodeDisplayType.TABLE],
    ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", StoryNodeDisplayType.TABLE],
    ["application/json", StoryNodeDisplayType.JSON],
    ["text/html", StoryNodeDisplayType.HTML],
    ["text/plain", StoryNodeDisplayType.TEXT],
]);
